<template>
  <transition name="fade">
    <article v-if="isActive" class="message" :class="[type]">
      <header v-if="title" class="message-header">
        <div>{{ title }}</div>
        <button v-if="closable" type="button" class="delete" :aria-label="ariaCloseLabel" @click="close">
          <d-icon icon="times" />
        </button>
      </header>
      <section class="message-body">
        <div class="media">
          <div v-if="hasIcon" class="media-left">
            <d-icon :icon="icon" />
          </div>
          <div class="media-content">
            <slot />
          </div>
        </div>
      </section>
    </article>
  </transition>
</template>

<script>
  import MessageMixin from '../../../utils/mixins/messageMixin.js';
  import DIcon from '../DIcon/DIcon.vue';

  /**
   * @displayName DMessage
   */
  export default {
    name: 'DMessage',
    components: {
      DIcon,
    },
    mixins: [MessageMixin],

    props: {
      /**
       * @ignore
       */
      ariaCloseLabel: {
        type: String,
        default: 'Close',
      },
    },
  };
</script>